import { useGetApprovalItemParticipations } from 'pages/approvals/hooks/useGetApprovalItemParticipations';
import { ParticipationRow } from 'pages/approvals/views/ParticipationRow';
import { useTranslation } from 'react-i18next';

/**
 * @param {import('models/approval.models').ApprovalItem} approvalItem
 */
export function ApprovalItemParticipations({ approvalItem }) {
    const { t } = useTranslation();
    const { items } = useGetApprovalItemParticipations(approvalItem['@id']);
    const directUsers = items.filter((participant) => participant.team === null);

    if (directUsers.length === 0) {
        return null;
    }

    const numberOfCompleted = directUsers.filter(
        (participation) => participation.action === 'completed' || participation.action === 'approved',
    ).length;

    return (
        <>
            <div
                className="font-weight-bold text-uppercase pb-2 mt-4"
                style={{
                    borderBottom: '1px solid #cbd5e1',
                    fontSize: 12,
                    letterSpacing: 0,
                    color: '#475569',
                }}
            >
                {t('ai:approvalItemParticipations.overview')} ({numberOfCompleted}/{directUsers.length})
            </div>

            {items.map((item) => (
                <ParticipationRow approvalItem={approvalItem} participation={item} key={`participation-${item.id}`} />
            ))}
        </>
    );
}
